<header #header class="position-absolute w-100" [ngClass]="{ 'sticky-header change-background': isSticky, 'disable-shadow': !isSticky }">
    <nav class="background navbar navbar-expand-lg center-nav transparent navbar-light">
        <div class="container flex-lg-row flex-nowrap align-items-center header-container">
            <div class="navbar-brand w-100">
                <a routerLink="/">
                    <img [ngClass]="{ hide: !isSticky }"dynamicImage *ngIf="landingPageData?.whiteLogo" [baseImageSrc]="landingPageData?.whiteLogo" [displayResolutions]="[IMAGES_RESOLUTIONS.xxs]" class="logo" alt="pageLogo" />
                    <img [ngClass]="{ hide: isSticky }"dynamicImage *ngIf="landingPageData?.blackLogo" [baseImageSrc]="landingPageData?.blackLogo" [displayResolutions]="[IMAGES_RESOLUTIONS.xxs]" class="logo" alt="pageLogo" />
                </a>
            </div>

            <!-- Skeleton Loader para el menú del header -->
            <div *ngIf="!landingPageData" class="skeleton-header-menu w-100 d-flex align-items-center justify-content-end">
                <div class="skeleton skeleton-title" style="width: 120px; height: 32px; margin-right: 24px;"></div>
                <div class="skeleton skeleton-title" style="width: 100px; height: 32px; margin-right: 24px;"></div>
                <div class="skeleton skeleton-title" style="width: 110px; height: 32px; margin-right: 24px;"></div>
                <div class="skeleton skeleton-title" style="width: 90px; height: 32px; margin-right: 24px;"></div>
                <div class="skeleton skeleton-title" style="width: 80px; height: 32px; margin-right: 24px;"></div>
                <div class="skeleton skeleton-btn" style="width: 140px; height: 36px;"></div>
            </div>

            <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start" *ngIf="landingPageData">
                <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
                    <ul class="navbar-nav p-navbar">
                        <li class="nav-item dropdown">
                            <a [ngStyle]="isSticky ? { color: '#FFFFFF' } : { color: '#2B2D2B' }" class="nav-link" routerLink="/">{{
                                "landing.home" | translateWithKeys
                            }}</a>
                        </li>

                        <li *ngIf="landingPageData?.showHeaderSections?.services" class="nav-item dropdown">
                            <a [ngStyle]="isSticky ? { color: '#FFFFFF' } : { color: '#2B2D2B' }"
                               class="nav-link dropdown-toggle"
                               href="#"
                               data-bs-toggle="dropdown"
                               aria-expanded="false">
                                {{ landingPageData?.showHeaderSections?.services_text === '' ? ("landing.careers" | translateWithKeys) : landingPageData?.showHeaderSections?.services_text }}
                            </a>
                            <ul class="dropdown-menu">
                                <ng-container *ngFor="let service of servicesLinks; let i = index">
                                    <li class="nav-item">
                                        <span class="dropdown-item" (click)="goToService(service.link, service.id)">{{service.name}}</span>
                                    </li>
                                </ng-container>
                            </ul>
                        </li>

                        <li *ngIf="landingPageData?.showHeaderSections?.aboutUs">
                            <a [ngStyle]="isSticky ? { color: '#FFFFFF' } : { color: '#2B2D2B' }" class="nav-link" routerLink="/about-us" aria-label="about-us">{{
                                "landing.about_us" | translateWithKeys
                            }}</a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a class="dropdown-item dropdown-toggle" routerLink="/about-us">{{ "landing.about_us" | translateWithKeys }}</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown" *ngIf="landingPageData?.showHeaderSections?.projects">
                            <a [ngStyle]="isSticky ? { color: '#FFFFFF' } : { color: '#2B2D2B' }" class="nav-link" routerLink="/projects/listing">
                                {{ landingPageData?.showHeaderSections?.projects_text === '' ? ("landing.projects" | translateWithKeys) : landingPageData?.showHeaderSections?.projects_text }}
                            </a>
                        </li>
                        <li *ngIf="landingPageData?.showHeaderSections?.blog">
                            <a [ngStyle]="isSticky ? { color: '#FFFFFF' } : { color: '#2B2D2B' }" class="nav-link" routerLink="/blog">
                                {{ landingPageData?.showHeaderSections?.blog_text === '' ? ("landing.blogs" | translateWithKeys) : landingPageData?.showHeaderSections?.blog_text }}
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <a class="dropdown-item dropdown-toggle" routerLink="/blog">{{ "landing.blogs" | translateWithKeys }}</a>
                                </li>
                            </ul>
                        </li>
                        <li *ngIf="landingPageData?.showHeaderSections?.careers">
                            <a [ngStyle]="isSticky ? { color: '#FFFFFF' } : { color: '#2B2D2B' }" class="nav-link" aria-label="Careers"  routerLink="/jobs">
                                {{ landingPageData?.showHeaderSections?.careers_text === '' ? ("landing.careers" | translateWithKeys) : landingPageData?.showHeaderSections?.careers_text }}
                            </a>

                            <ul class="dropdown-menu">
                                <li>
                                    <a class="dropdown-item dropdown-toggle" routerLink="/job-listing">{{ landingPageData?.showHeaderSections?.careers_text === '' ? ("landing.careers" | translateWithKeys) : landingPageData?.showHeaderSections?.careers_text }}</a>
                                </li>
                            </ul>
                        </li>

                        <li *ngIf="screenWidth > 1024" class="nav-item contact-btn">
                            <div class="row">
                                <button [ngClass]="{ 'change-background': isSticky, 'disable-shadow': !isSticky }" (click)="goToLink(landingPageData.showHeaderSections.contact_us_link)" mat-button class="contact-btn-container">
                                    <span class="contact-nav-link">{{ landingPageData?.showHeaderSections?.contact_us_text === '' ? ("landing.contact" | translateWithKeys) : landingPageData?.showHeaderSections?.contact_us_text }}</span>
                                </button>
                            </div>
                        </li>
                        <li *ngIf="!showLanguageVC" class="nav-item dropdown ">
                            <button [ngStyle]="isSticky ? { color: '#FFFFFF' } : { color: '#2B2D2B' }" type="button" aria-haspopup="menu" aria-expanded="false"
                                class="nav-link p-link"
                                [matMenuTriggerFor]="userMenuLanguage">
                                {{ selectedLanguage  | uppercase }}
                            </button>
                            <mat-menu #userMenuLanguage="matMenu">
                                <mat-radio-group [(ngModel)]="selectedLanguage " (change)="changeLanguage($event.value)">
                                    <button mat-menu-item color="primary" >
                                        <mat-radio-button value="en" color="primary">EN</mat-radio-button>
                                    </button>
                                    <button mat-menu-item color="primary">
                                        <mat-radio-button value="es" color="primary">ES</mat-radio-button>
                                    </button>
                                </mat-radio-group>
                            </mat-menu>
                        </li>
                    </ul>

                </div>
            </div>

            <div *ngIf="screenWidth < 1024" class="navbar-other w-100 d-flex ms-auto hamburger-container">
                <div *ngIf="!isSticky" class="example-sidenav-content">
                    <button type="button" mat-icon-button (click)="drawer.toggle()" [ngClass]="{ 'color-white': isSticky, 'color-black': !isSticky }">
                        <mat-icon class="icons" svgIcon="app_menu"></mat-icon>
                    </button>
                </div>
                <div *ngIf="isSticky" class="example-sidenav-content">
                    <button type="button" mat-icon-button (click)="drawer.toggle()" [ngClass]="{ 'color-white': isSticky, 'color-black': !isSticky }">
                        <mat-icon class="icons" svgIcon="app_menu"></mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </nav>
</header>

<mat-drawer-container [ngClass]="{ hide: screenWidth >= 1024 }" class="example-container" autosize>
    <mat-drawer #drawer class="example-sidenav" mode="over">
        <div class="btn-container">
            <div class="logo-container">
                <a routerLink="/">
                    <img dynamicImage [baseImageSrc]="landingPageData?.whiteLogo" [displayResolutions]="[IMAGES_RESOLUTIONS.xxs, IMAGES_RESOLUTIONS.xs]" class="logo-sidebar" alt="pageLogo" />
                </a>
                <mat-icon (click)="drawer.toggle()"></mat-icon>
            </div>
            <div (click)="drawer.toggle()">
                <button *ngIf="landingPageData?.showHeaderSections?.projects" mat-menu-item (click)="goTo('/projects/listing')" >{{ landingPageData?.showHeaderSections?.projects_text === '' ? ("landing.projects" | translateWithKeys) : landingPageData?.showHeaderSections?.projects_text }}</button>
                <button *ngIf="landingPageData?.showHeaderSections?.blog" mat-menu-item (click)="goTo('/blog')">{{ landingPageData?.showHeaderSections?.blog_text === '' ? ("landing.blogs" | translateWithKeys) : landingPageData?.showHeaderSections.blog_text }}</button>
                <button *ngIf="landingPageData?.showHeaderSections?.careers" mat-menu-item (click)="goTo('/jobs')">{{ landingPageData?.showHeaderSections?.careers_text === '' ? ("landing.careers" | translateWithKeys) : landingPageData?.showHeaderSections?.careers_text }}</button>
                <button *ngIf="landingPageData?.showHeaderSections?.contactUs" mat-menu-item (click)="goToLink(landingPageData.showHeaderSections.contact_us_link)">{{ landingPageData?.showHeaderSections?.contact_us_text === '' ? ("landing.contact" | translateWithKeys) : landingPageData?.showHeaderSections?.contact_us_text }}</button>
                <button *ngIf="landingPageData?.showHeaderSections?.aboutUs" mat-menu-item (click)="goTo('/about-us')">{{ landingPageData?.showHeaderSections?.about_us_text === '' ? ("landing.about_us" | translateWithKeys) : landingPageData?.showHeaderSections?.about_us_text }}</button>
            </div>
            <mat-accordion *ngIf="!showLanguageVC">
                <mat-expansion-panel hideToggle (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="font">{{'langs.languaje' | translateWithKeys}}</span>
                    </mat-panel-title>

                    </mat-expansion-panel-header>
                    <mat-radio-group *ngIf="!showLanguageVC" [(ngModel)]="selectedLanguage" (change)="changeLanguage($event)">
                        <button mat-menu-item color="primary">
                            <mat-radio-button value="en" color="primary">{{'langs.english' | translateWithKeys}}</mat-radio-button>
                        </button>
                        <button mat-menu-item color="primary">
                            <mat-radio-button value="es" color="primary">{{'langs.spanish' | translateWithKeys}}</mat-radio-button>
                        </button>
                    </mat-radio-group>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion>
                <mat-expansion-panel hideToggle (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="services-expansion-panel">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span class="font">Services</span>
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                    <mat-radio-group>
                        <ng-container *ngFor="let service of servicesLinks; let i = index">
                            <button mat-menu-item class="services-expansion-panel" (click)="drawer.toggle()">
                                <span (click)="goToService(service.link, service.id)">{{ service.name }}</span>
                            </button>
                        </ng-container>
                    </mat-radio-group>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

    </mat-drawer>
</mat-drawer-container>
